"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultItemsPerPage = void 0;
exports.defaultItemsPerPage = 25;
//# sourceMappingURL=collection.js.map